import {Controller} from "stimulus"

// Files a planning case under the case picked from a shortcode search,
// posting to the case's parent resource so the server can refuse anything
// that would nest the family deeper than one level.
export default class extends Controller {

    setParent(e) {
        e.preventDefault()
        const result = e.target.closest(".result-planning-case")
        if (result == null) return

        const form = document.createElement("form")
        form.method = "post"
        form.action = window.location.pathname + "/parent"
        form.appendChild(this.hiddenField("authenticity_token", this.csrfToken()))
        form.appendChild(this.hiddenField("parent_id", result.id))
        document.body.appendChild(form)
        form.submit()
    }

    hiddenField(name, value) {
        const field = document.createElement("input")
        field.type = "hidden"
        field.name = name
        field.value = value
        return field
    }

    csrfToken() {
        const meta = document.querySelector("meta[name='csrf-token']")
        return meta == null ? "" : meta.getAttribute("content")
    }
}
